import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { AsyncSubject, BehaviorSubject } from 'rxjs';

function getCookie(name: string): boolean {
  return document.cookie.split(';').some((c) => {
    return c.trim().startsWith(name + '=');
  });
}

/**
 * Test-mode stand-in for `AuthService`. Skips real MSAL interaction and
 * synthesises an `AccountInfo` so the rest of the app can render.
 */
@Injectable({
  providedIn: 'root',
})
export class TestAuthService {
  public currentUser = new BehaviorSubject<AccountInfo | null>(null);
  public authenticated = new AsyncSubject<boolean>();

  constructor() {
    if (getCookie('ROLE_COOKIE')) {
      setTimeout(() => {
        this.currentUser.next({
          homeAccountId: 'test-home-account-id',
          environment: 'test',
          tenantId: 'test-tenant',
          username: 'test-user',
          localAccountId: 'test-local-account-id',
          name: 'Test User',
        });
        this.authenticated.next(true);
        this.authenticated.complete();
      }, 500);
    } else {
      this.authenticated.next(false);
      this.authenticated.complete();
    }
  }

  public signout() {}

  public signinRedirect() {}

  canActivate() {
    return true;
  }
}
